package models

import kotlinx.serialization.Serializable

@Serializable
data class FavoriteVideo(
    val videoId: Int,
    val title: String?,
    val imageUrl: String?,
    val isTvShow: Boolean,
    val isDeleted: Boolean,
)
